import { ChartScatterPlotIcon } from './ChartScatterPlotIcon';

/**
 * author: Michael Irigoyen
 * id C268C5A5-0D35-4963-9151-61D2C442015B
 * name chart-scatter-plot
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-scatter-plot.svg
 * tags
 * - Math 
 */
export const ReportScatterPlotIcon = ChartScatterPlotIcon;
export default ReportScatterPlotIcon